import { TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import useLang from "../../../../Shared/hooks/useLanguage";
import { CrossIcon, DoneIcon } from "../../../../Shared/Icons";
import { TestSetupSaveData } from "Services/NGSCompendium";
import PermissionComponent from "Shared/Common/Permissions/PermissionComponent";
import { reactSelectSMStyle, styles } from "Utils/Common";
import { validateFields } from "Pages/LIS/Toxicology/CommonFunctions";

function Row({
  row,
  rows,
  index,
  setRows,
  referenceLab,
  GetAllTestSetupData,
  queryDisplayTagNames,
  setIsAddButtonDisabled,
  handleChangePerformingLab,
}: any) {
  const { t } = useLang();

  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const getValues = (r: any) => {
    const updatedRows = rows.map((row: any) => {
      if (row.testId === r.testId) {
        return { ...row, rowStatus: true };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handleChange = (name: string, value: string, testId: number) => {
    setRows((curr: any) =>
      curr.map((x: any) => (x.testId === testId ? { ...x, [name]: value } : x))
    );
  };

  const handlesave = async () => {
    const { isValid, invalidField } = validateFields({
      testName: row.testName,
      labId: row.labId,
      testCode: row.testCode,
      orderCode: row.orderCode,
      tmitCode: row.tmitCode,
    });

    if (!isValid) {
      const errorMessage = invalidField
        ? `Please Fill ${queryDisplayTagNames[invalidField] ?? ""} field`
        : "Invalid field found";
      toast.error(errorMessage);
      return;
    }

    const payload = {
      testId: row.testId,
      testConfigId: row.testConfigId,
      testName: row.testName,
      labId: row.labId,
      labName: row.labName,
      testCode: row.testCode,
      orderCode: row.orderCode,
      tmitCode: row.tmitCode,
    };

    try {
      setDisableSaveBbutton(true);

      const res = await TestSetupSaveData(payload);

      if (res?.data?.httpStatusCode === 200) {
        GetAllTestSetupData();
        setIsAddButtonDisabled(false);
        handleClose("dropdown2");
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Save failed:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setDisableSaveBbutton(false);
    }
  };

  return (
    <>
      <TableRow className="h-30px">
        <TableCell>
          <div className="d-flex justify-content-center">
            {row?.rowStatus ? (
              <div className="gap-2 d-flex">
                <button
                  disabled={disableSaveBbutton}
                  id={`NGSCompendiumSave`}
                  onClick={() => {
                    handlesave();
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-save btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <DoneIcon />
                </button>
                <button
                  id={`NGSCompendiumCancel`}
                  onClick={() => {
                    GetAllTestSetupData();
                    handleClose("dropdown2");
                    if (row?.id !== 0) {
                      const updatedRows = rows.map((r: any) => {
                        if (r.id === row?.id) {
                          return { ...r, rowStatus: false };
                        }
                        return r;
                      });
                      setRows(updatedRows);
                    } else {
                      const newArray = [...rows];
                      newArray.splice(index, 1);
                      setRows(newArray);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <CrossIcon />
                </button>
              </div>
            ) : (
              <div className="rotatebtnn">
                <DropdownButton
                  className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                  key="end"
                  id={`NGSCompendium3Dots_${row.id}`}
                  drop="end"
                  title={<i className="bi bi-three-dots-vertical p-0"></i>}
                >
                  <PermissionComponent
                    moduleName="NGS LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="Edit"
                  >
                    <Dropdown.Item
                      id={`NGSCompendiumEdit`}
                      className="w-auto"
                      eventKey="2"
                      onClick={() => {
                        getValues(row);
                      }}
                    >
                      <i className={"fa fa-edit text-primary mr-2"}></i>
                      {t("Edit")}
                    </Dropdown.Item>
                  </PermissionComponent>
                </DropdownButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell
          id={`NGSCompendiumtestName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSCompendiumDisplayName`}
                type="text"
                placeholder={t("Display Name")}
                name="testName"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.testName}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.testId)
                }
              />
            </div>
          ) : (
            row?.testName
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumDisplayText_${row.id}`}
          sx={{ width: "max-content" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <div className="w-100">
                <Select
                  inputId={`NGSCompendiumDataTestSetupGroup`}
                  menuPortalTarget={document.body}
                  theme={(theme) => styles(theme)}
                  options={referenceLab}
                  name="labId"
                  styles={reactSelectSMStyle}
                  placeholder={t("Performing Lab")}
                  value={referenceLab.find((i: any) => i.value === row.labId)}
                  onChange={(e: any) =>
                    handleChangePerformingLab(row.testId, e)
                  }
                />
              </div>
            </div>
          ) : (
            row?.labName
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumtestCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSCompendiumtestCode`}
                type="text"
                placeholder={t("Display Name")}
                name="testCode"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.testCode || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.testId)
                }
              />
            </div>
          ) : (
            row?.testCode
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumorderCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSCompendiumorderCode`}
                type="text"
                placeholder={t("Display Name")}
                name="orderCode"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.orderCode || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.testId)
                }
              />
            </div>
          ) : (
            row?.orderCode
          )}
        </TableCell>
        <TableCell
          id={`NGSCompendiumtmitCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`NGSCompendiumtmitCode`}
                type="text"
                placeholder={t("TMIT Name")}
                name="tmitCode"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.tmitCode || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.testId)
                }
              />
            </div>
          ) : (
            row?.tmitCode
          )}
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
